import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { StatusOptions } from '@config/status.config';
import { DialogService } from '@lib/services/dialog.service';
import { AlertsService } from '@lib/services/error-handling/alerts.service';
import { HelperService } from '@lib/services/helper.service';
import { HttpService } from '@lib/services/http/http.service';
import { CityDto } from '@models/dtos/core';
import { NotificationRemarksComponent } from '../notificationremarks/notificationremarks.component';

@Component({
  selector: 'gnx-notificationremarks-policy',
  templateUrl: './notificationremarks-policy.component.html',
  styleUrls: ['./notificationremarks-policy.component.scss']
})
export class NotificationremarksPolicyComponent {


  // #region public variables

  // Strings
  title: string = '';
  Code: string;
  statusOption = StatusOptions

  // FormGroup
  NotificationRemarksForm: FormGroup;
  cityFrom: CityDto
  addCityForm: any


  editable: boolean;
  // Errors
  errors: unknown;

  stateList;

  // #endregion public variables

  /**
   * #region constructor
   * @param _location : used for back or prev page navigation
   * @param _fb : Formbuilder
   * @param _router: module for routing
   * @param _route: used to get current route
   */
  constructor(
    private _fb: FormBuilder,
    private _dataService:HttpService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _alertservice: AlertsService,
    public _helperservice: HelperService,
    public dialogRef: MatDialogRef<NotificationRemarksComponent>,
    private _dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: string;
      title: string;
      isMultiple: boolean;
      data?: any;
      policydto: any;
    }
  ) {
  }


  ngOnInit(): void {
    this._init();
    this.NotificationRemarksForm.patchValue(this.data.policydto)
    this.editable = true;

  }
  // #endregion constructor

  // #region getters

  get f() {
    return this.NotificationRemarksForm.controls
  }

  // #endregion getters

  /**
   * #region public methods
   */

  // submit or save action
  submitform = () => {
    this._dialogService.confirmDialog({
      title: 'Are You Sure?',
      message: "You won't be able to revert this",
      confirmText: 'Yes',
      cancelText: "No"
    }).subscribe(res => {
      if (res) {
      this.dialogRef.close(this.NotificationRemarksForm.value);
    }
  });
  };

  // previous page navigation button
  public backClicked() {
    this.dialogRef.close();
  }

  // #endregion public methods
  /**
   * #region private methods
   */

  private _init(): FormGroup {
    this.NotificationRemarksForm = this._fb.group({
      RRNo: [''],
      RRDate: [''],
      RailAuthorityName: [''],
      BuyerConsignee: [''],
      SellerConsignor: [''],
      JobNo: [''],
      AdditionalInfo: [''],
      PurchaseTransitModeId: [null],
      PurchaseTransitModeName: [''],
      SalesTransitModeId: [null],
      SalesTransitModeName: [''],
      TransitTypeId: [null],
    });

    return this.NotificationRemarksForm;
  }

}

